var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "exit_svg__st0",
    d: "M22 0H2C.9 0 0 .9 0 2v8.5h12.46L9.17 7.64c-.62-.54-.69-1.49-.15-2.12.54-.63 1.49-.69 2.12-.15l6.31 5.49c.1.09.19.18.26.29.07.11.13.23.18.35.05.16.08.32.08.48 0 .16-.03.32-.08.48-.04.12-.1.24-.18.35-.07.11-.16.21-.26.29l-6.31 5.49c-.28.25-.63.37-.98.37-.42 0-.84-.17-1.13-.52-.54-.62-.48-1.57.15-2.12l3.29-2.86H0V22c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
  })));
};
export default SvgExit;